import _extends from 'babel-runtime/helpers/extends';

import _ from 'lodash';
import { mapState, mapMutations, mapActions } from 'vuex';
import { groupItemMixin } from '@/views/creative/mixin/index.js';
import categoryMixin from '@/views/creative/mixin/category.js';
import GroupLegend from '../components/group-legend.vue';
import ToggleVisibleBtn from './toggle-visible-button.vue';
import ResetResource from '../components/reset-resource.vue';
import BackgroundColor from '../components/global-config/background-color.vue';

export default {
  props: {
    isSubCategory: {
      type: Boolean,
      default: false
    }
  },

  mixins: [groupItemMixin, categoryMixin],

  components: {
    GroupLegend: GroupLegend,
    ToggleVisibleBtn: ToggleVisibleBtn,
    ResetResource: ResetResource,
    BackgroundColor: BackgroundColor
  },

  data: function data() {
    return {};
  },


  computed: _extends({}, mapState({
    templateConfig: function templateConfig(state) {
      return state.creative.template.templateConfig;
    },
    currentCategory: function currentCategory(state) {
      return state.creative.template.currentCategory;
    }
  }), {
    properties: function properties() {
      return this.category.properties;
    },
    globalConfig: function globalConfig() {
      return _.get(this.category, 'properties.globalConfig');
    },
    bgColor: function bgColor() {
      return _.get(this.globalConfig, 'value') || '';
    }
  }),

  mounted: function mounted() {
    // console.log(this.category)
  },


  methods: _extends({}, mapMutations({
    updateCurrentCategory: 'creative/template/updateCurrentCategory',
    addValidator: 'creative/template/addValidator'
  }), mapActions({
    updateTargetCategory: 'creative/template/updateTargetCategory'
  }), {
    handleChange: function handleChange(val) {
      this.updateTargetCategory({
        properties: _extends({}, this.properties, {
          globalConfig: _extends({}, this.globalConfig, {
            value: val
          })
        }),
        id: this.category.id
      });
    },
    handleReset: function handleReset(id) {
      this.updateTargetCategory({
        properties: _extends({}, this.properties, {
          globalConfig: _extends({}, this.globalConfig, {
            value: this.globalConfig.originalValue || ''
          })
        }),
        id: id
      });
    }
  })
};